import * as types from './ActionTypes';
import { trxorder, errors } from '../services/';

export const state = {
	type: '',
	majorSatus: false,
	curChooseType: 0,
	priceType: '',
	activityId: '',
	createdStatus: false,
	number: 0,
	total: 0,
	fromType: 0,
	tradeType: 'NATIVE',
	showMajor: true,
	leftSlide: '',
};
export const mutations = {
	[types.SET_MAJOR_STATUS](state, status) {
		state.majorSatus = status;
	},
	[types.SET_CHOOSETYPE_STATUS](state, status) {
		state.curChooseType = status;
	},
	[types.SET_PRICETYPE_STATUS](state, status) {
		state.priceType = status;
	},
	[types.SET_ACTIVITYID_STATUS](state, status) {
		state.activityId = status;
	},
	[types.SET_CREATED_STATUS](state, status) {
		state.createdStatus = status;
	},
	[types.SET_LEFT_SLIDE](state, data) {
		state.leftSlide = data;
	},
	[types.SET_MAJOR_TYPE](state, type) {
		state.type = type;
	},
	[types.SET_MAJOR_COUNT](state, number) {
		state.number = number;
	},
	[types.SET_MAJOR_TOTAL](state, total) {
		state.total = total;
	},
	[types.SET_SHOW_MAJOR](state, type) {
		state.showMajor = type;
	},
	// [types.SET_MAJOR_FROMTYPE](state, obj) {
	// 	state.fromType = obj.fromType;
	// 	state.tradeType = obj.tradeType;
	// },
	[types.SET_MAJOR_EMPTY](state) {
		// TODO fix here
		for (let key in state) {
			if (key == 'createdStatus') {
				state[key] = false;
				continue;
			}
			state[key] =
				key === 'number' || key === 'total' || key === 'fromType'
					? 0
					: key === 'majorSatus'
					? false
					: key === 'tradeType'
					? 'NATIVE'
					: '';
		}
	},
};
export const actions = {
	async getTotal({ state, commit }, type) {
		// state.type !== type ? (state.type = type) : ''; //更新总价前更改类型
		commit('SET_MAJOR_TYPE', type ? type : state.type);

		if (state.number) {
			try {
				const { data, ok } = await trxorder.getActualPrice(state.number, { type: state.type });
				if (!ok) {
					return;
				}
				commit('SET_MAJOR_TOTAL', data.data.activityAmount);
			} catch (e) {
				errors(e);
			}
		} else {
			commit('SET_MAJOR_TYPE', '');
			commit('SET_MAJOR_TOTAL', 0);
		}
	},
};
